export interface IVideoPlayerWidgetState {
    image: string,
    videoActive: boolean,
    player: any
}

export default class VideoPlayerWidgetState implements IVideoPlayerWidgetState {
    image = '';
    player: any;
    videoActive = false;
}
